import {DatabaseService} from './../../../database/database.service';
import {CxCheckBoxComponent} from '../../../libs/components/cx-check-box/cx-check-box.component';
import {AuthService} from './../../auth.service';
import {Component, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ILoginReq} from '../../model/login-req';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {Router, ActivatedRoute} from '@angular/router';
import {CxAlertsService} from '@app/libs/components/cx-alerts/cx-alerts.service';
import * as bcrypt from 'bcryptjs';
import {BackgroundSyncService} from '@app/helpers/backgroundSync.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public debugMode: true;
  public loginReq: ILoginReq;
  public isHidePassword = false;
  public typePassword = 'password';
  public loginForm: FormGroup;
  public errorMessage: string;
  public isError = false;
  public userLogged: any;
  @ViewChild(CxCheckBoxComponent) checkBoxChild;
  isSaveUser: boolean;

  constructor(
    private loginService: AuthService,
    private router: Router,
    private formBuilder: FormBuilder,
    private route: ActivatedRoute,
    private alertService: CxAlertsService,
    private databaseService: DatabaseService,
    private backgroundSyncService: BackgroundSyncService
  ) {
    this.debugMode = true;
    this.loginReq = new ILoginReq('', '');
    this.loginForm = this.formBuilder.group({
      user: ['', [Validators.required]],
      pass: ['', [Validators.required]],
    });
    this.isSaveUser = false;
  }

  ngOnInit(): void {
    this.loginReq.user = localStorage.getItem('mlUser');
    this.isSaveUser = false;
    this.loginService.currentUser.subscribe((user) =>
      JSON.stringify((this.userLogged = user))
    );
  }

  receiveMessage(): void {
    this.isSaveUser = this.checkBoxChild.value;
  }

  onSubmit(): void {
    if (this.isSaveUser) {
      this.saveUser();
    }
    this.login();
  }

  hidePassword(): void {
    this.isHidePassword = !this.isHidePassword;
    if (this.typePassword === 'password') {
      this.typePassword = 'text';
    } else {
      this.typePassword = 'password';
    }
  }

  loginOnline(): void {
    localStorage.removeItem('filtroperiodicos');
    localStorage.removeItem('filtroreevaluacion');
    localStorage.removeItem('configPageperiodicos');
    localStorage.removeItem('configPagereevaluacion');
    this.databaseService.clearTableExamanesPeriodicosFiltrados();
    this.databaseService.clearTableExamanesReevaluacionFiltrados();
    this.loginService
      .loginOnline(this.loginReq.user, this.loginReq.password)
      .subscribe(
        (result) => {
          this.router.navigate(['/examenes/true']);
          this.backgroundSyncService.checkPorEnviarTableChange(true);
          this.getUsersOffline();
        },
        (error) => {
          this.isError = true;
          this.errorMessage = error.error.message;
          if (error.status === 0) {
            this.errorMessage = 'Ocurrió un error al iniciar sesión. Comuníquese con el administrador.';
          }
          this.alertService.openAlertWarn(this.errorMessage);
        }
      ),
      catchError((error) => {
        return throwError('The login process could not be executed!');
      });
  }

  loginOffline(): void {
    let plainText = this.loginReq.user + this.loginReq.password;
    plainText = plainText.trim();
    this.loginService.loginOffline(
      plainText,
      this.loginReq.user,
      this.loginReq.password
    );
  }

  resetPasword(): void {
    alert('Pronto podrá recuperar la contraseña. 🔐🔐🔐');
  }

  /**
   * ? NOTE:
   * * en estas dos funciones podrás encontrar un
   * * un ejemplo de como implementar un dato o valor retornado por
   * * alguna función get del DatabaseService
   */
  private validateIsOnline(): Promise<any> {
    return this.databaseService.getOnlineStatusFromOfflineDB();
  }

  /**
   * ? NOTE:
   * * para que funcione la función que utiliza el valor concreto
   * * retornado por una función del tipo: this.databaseService.getSomeDataFromOfflineDB()
   * * deberá implementarse con async y await para evitar problemas de sincronismo
   */
  private async login(): Promise<void> {
    const isOnline = await (await this.validateIsOnline()).isStillOnline;
    if (isOnline) {
      this.loginOnline();
    } else {
      this.loginOffline();
    }
  }

  private saveUser(): void {
    localStorage.setItem('mlUser', this.loginReq.user);
  }

  private addDays(date, days) {
    date.setDate(date.getDate() + days);
    return date;
  }

  private getUsersOffline(): void {
    this.loginService.getUsersOffline().subscribe(
      (response) => {
        /**
         * TODO: Agregar datos a DB, inyectar el servicio
         */
        const today = new Date();
        const expirationDateOfflineUsers = this.addDays(today, 5);

        const usersOffline = {
          usuarios: response.response.usuarios,
          expirationDate: expirationDateOfflineUsers,
          api: true,
        };
        this.databaseService.updateUsuariosOnOfflineDB(usersOffline.usuarios);
        this.databaseService.updateOfflineUsersOnOfflineDB(usersOffline);
        localStorage.setItem('offlineUsers', JSON.stringify(usersOffline));
      },
      (error) => {
        this.errorInGetUsersOffline();
      }
    );
  }

  private errorInGetUsersOffline(): void {
    const userValue = this.loginReq.user;
    const passValue = this.loginReq.password;
    const today = new Date();
    const expirationDateOfflineUsers = this.addDays(today, 5);
    const user = this.userLogged;
    bcrypt.genSalt(10, (err, salt) => {
      bcrypt.hash(userValue, salt, (err, hashUser) => {
        console.log(userValue, hashUser);
        bcrypt.genSalt(10, (err, salt) => {
          bcrypt.hash(passValue, salt, async (err, hashPass) => {
            console.log(passValue, hashPass);
            const obj = {
              expirationDate: expirationDateOfflineUsers,
              api: false,
              usuarios: [
                {
                  modelId: user.modelId,
                  modelName: user.modelName,
                  userToken: hashUser,
                  passToken: hashPass,
                  userId: user.userId,
                },
              ],
            };
            await this.databaseService.updateOfflineUsersOnOfflineDB(obj);
            this.databaseService.updateUsuariosOnOfflineDB(obj.usuarios);
            localStorage.setItem('offlineUsers', JSON.stringify(obj));
          });
        });
      });
    });
  }
}
